import app from "@/main";
import Vue from "vue";
import * as ENDPOINTS from "./endpoints";
import { resolveRequestError } from "@/utils/auth";

export default class AdminService {

    // =========== ONBOARD ADMIN ==========
    static async onboardAdmin({ email, phonenumber, permissions }){
        try {
            const { data } = await Vue.http.post(ENDPOINTS.ADMIN, {
                email,
                phonenumber,
                permissions
            })
            app.$store.dispatch('toast', {
                message: data.message,
                variant: 'success'
            })
            return data
        } catch (error) {
            resolveRequestError(error)
        }
    }

    // ============ GET ALL ADMINS  =============
    static async getAdmins(){
        try{
            const { data } = await Vue.http.get(ENDPOINTS.ADMIN);
            return data;
        }
        catch(error){
            resolveRequestError(error)
        }
    }

    // ========= GET ALL AUDIT LOGS ===============
    static async getAudits( {  page, limit }){
        try {
            const { data } = await Vue.http.get(ENDPOINTS.AUDITS, {
                params:{
                    page,
                    limit
                }
            })
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }

    //  ========= GET ADMIN PROFILE ==========
    static async getProfile(){
        try {
            const { data } = await Vue.http.get(ENDPOINTS.PROFILE);
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }

    // =========== EDIT ADMIN PROFILE ==========
    static async editProfile(payload){
        try {
            const { data } = await Vue.http.patch(ENDPOINTS.PROFILE,payload)
            return data
        } catch (error) {
            resolveRequestError(error)
        }
    }

    // ============ CHANGE PASSWORD =================
    static async changePassword(payload){
        try {
            const { data  } = await Vue.http.patch(ENDPOINTS.CHANGEPASSWORD, payload);
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }
     // ============ CHANGE PIN =================
     static async changePin(payload){
        try {
            const { data  } = await Vue.http.patch(ENDPOINTS.CHANGEPIN, payload);
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }

 



}